import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';

@Component({
    selector: 'share-admin-dialog',
    templateUrl: 'share-admin-dialog.html',
    styleUrls: ['share-superadmin-dialog.css']
})
export class shareSurvey {
    email: string;
    isSharable:boolean;
    isInvalid:boolean;
    constructor(
    public dialogRef: MatDialogRef<shareSurvey>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.isSharable  = true;
      this.isInvalid = false;
    }

    onYes(email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          this.isInvalid = false;
          this.isSharable  = true;
            this.restApiService.shareQnr(email, this.data.qID).subscribe(
                result => {
                  if(result.success==false){
                    this.isSharable  = false;
                  }
                  else {
                    // console.log(result);
                    this.dialogRef.close();
                  }
                });
        }
        else {
          this.isInvalid = true;
        }
    }

    onNo() {
      this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/share-admin-dialog.ts